import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export default function KineticText({ text, step = 0.035, delay = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.6 });
  const [run, setRun] = useState(0);

  useEffect(() => {
    if (inView) setRun((r) => r + 1);
  }, [inView]);

  return (
    <span ref={ref} aria-label={text} role="text">
      {text.split("").map((ch, i) => (
        <span
          key={`${run}-${i}`}
          aria-hidden="true"
          className={run ? "kinetic-letter" : "opacity-0"}
          style={{ animationDelay: `${delay + i * step}s` }}
        >
          {ch === " " ? "\u00A0" : ch}
        </span>
      ))}
    </span>
  );
}
